import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

import supcArrival from "@/assets/insights/Arrival_SUPC_2026_at_JIBS.webp";
import awardCeremony from "@/assets/insights/Tanja_Tanaka_Elias_Sundin_and_Benjamin_Bark_at_the_award_ceremony.webp";
import boardPhoto from "@/assets/insights/The_JSA_Investment_Club_Board.webp";

const articles = [
  {
    title: "SUPC 2026: One Of Scandinavia's Largest Student Pitch Competition",
    date: "February 2026",
    category: "Events",
    image: supcArrival,
    slug: "supc-2026",
  },
  {
    title: "Award Ceremony Highlights",
    date: "February 2026",
    category: "Recap",
    image: awardCeremony,
    slug: "supc-2026",
  },
  {
    title: "Meet the JIC Board 2025/26",
    date: "September 2025",
    category: "Team",
    image: boardPhoto,
    slug: "",
    href: "/team?tab=current",
  },
];

const InsightsPreview = () => {
  return (
    <section className="py-24 md:py-32 bg-navy-dark text-paper">
      <div className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <span className="text-steel-light uppercase tracking-[0.3em] text-[10px] font-bold mb-4 block">
              Latest Analysis
            </span>
            <h2 className="font-serif text-4xl lg:text-5xl text-paper">
              News &amp; Insights
            </h2>
          </div>
          <Link
            to="/insights"
            className="text-steel-light font-bold text-[11px] uppercase tracking-[0.25em] border-b-2 border-steel-light pb-1 hover:text-paper hover:border-paper transition-colors inline-flex items-center gap-2 self-start"
          >
            View all insights
            <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-10 lg:gap-12">
          {articles.map((article) => (
            <Link
              key={article.title}
              to={article.href || `/insights${article.slug ? `?article=${article.slug}` : ""}`}
              className="group"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-navy mb-6">
                <img
                  src={article.image}
                  alt={article.title}
                  className={`w-full h-full object-cover transition-all duration-700 group-hover:scale-105 group-active:scale-105 ${
                    article.category === "Team" ? "grayscale group-hover:grayscale-0 group-active:grayscale-0" : ""
                  }`}
                  loading="lazy"
                  decoding="async"
                />
                {article.category === "Team" && (
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 shadow-glass opacity-0 translate-y-2 group-hover:opacity-100 group-active:opacity-100 group-hover:translate-y-0 group-active:translate-y-0 transition-all duration-300">
                      <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-paper">Meet the board</span>
                      <ArrowUpRight className="w-4 h-4 text-paper" />
                    </div>
                  </div>
                )}
                <div className="absolute top-4 left-4 bg-steel text-paper px-3 py-1 text-[9px] font-bold tracking-[0.2em] uppercase">
                  {article.category}
                </div>
              </div>
              <div className="text-paper/60 text-[10px] font-bold tracking-[0.2em] uppercase mb-3">
                {article.date}
              </div>
              <h3 className="font-serif text-2xl leading-snug text-paper group-hover:text-steel-light group-active:text-steel-light transition-colors">
                {article.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsightsPreview;
